import { ConfigJsonService } from './config-json.service';

export function initConfig(config: ConfigJsonService) {
   return () => {
      return config.init(null);
   };
}

